// extracted by mini-css-extract-plugin
export var aboveInput = "_n3-0";
export var actionButton = "_n3-5";
export var actionButtonContainer = "_n3-1";
export var actionIcon = "_n3-6";
export var aiInfoContainer = "_n3-2";
export var attachmentWrapper = "_n3-7";
export var bold = "_n3-3";
export var checkIcon = "_n3-8";
export var clickingRecipientBar = "_n3-11";
export var commentThreadSwitch = "_n3-a";
export var draftImage = "_n3-b";
export var draftImageContainer = "_n3-c";
export var draftImages = "_n3-e";
export var editButton = "_n3-g";
export var editor = "_n3-f";
export var editorContainer = "_n3-y";
export var editorErrorTooltipWrapper = "_n3-9";
export var headerDivider = "_n3-h";
export var icon = "_n3-i";
export var info = "_n3-j";
export var internal = "_n3-n";
export var internalDivider = "_n3-k";
export var internalMessage = "_n3-l";
export var messageInputCard = "_n3-m";
export var messageInputForm = "_n3-o";
export var messageInputFormInternal = "_n3-p";
export var options = "_n3-q";
export var publicMessageCustomer = "_n3-s";
export var publicMessageMerchant = "_n3-r";
export var removeImageButton = "_n3-d";
export var replyButtons = "_n3-t";
export var showSignatureButton = "_n3-u";
export var spinner = "_n3-v";
export var verticalButtonDivider = "_n3-4";
export var visibilitySelector = "_n3-w";
export var warning = "_n3-x";
export var wrappingText = "_n3-z";
export var writingInternalNoteTopBorder = "_n3-10";